// The few glyphs only the installed-app pieces draw (same 24-unit stroke grid as design/icons.tsx).
import type { CSSProperties } from 'react';

const paths = {
  sparkles: (
    <>
      <path d="M12 3.5l1.6 4.4L18 9.5l-4.4 1.6L12 15.5l-1.6-4.4L6 9.5l4.4-1.6Z" />
      <path d="M18.5 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7Z" />
    </>
  ),
  speaker: (
    <>
      <path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4Z" />
      <path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" />
    </>
  ),
  shieldAlert: (
    <>
      <path d="M12 3.5 5 6.2v5.3c0 4.3 2.9 7.6 7 9 4.1-1.4 7-4.7 7-9V6.2z" />
      <path d="M12 8.5v4M12 15.6v.1" />
    </>
  ),
  arrowUpCircle: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 16V8.5M8.5 11.5 12 8l3.5 3.5" />
    </>
  ),
  share: (
    <>
      <path d="M12 3.5v11M8 7.5l4-4 4 4" />
      <path d="M6 11.5H5a1 1 0 0 0-1 1V19a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 20 19v-6.5a1 1 0 0 0-1-1h-1" />
    </>
  ),
};

export type PwaIconName = keyof typeof paths;

export function PwaIcon({ name, size = 18, strokeWidth = 1.7, style }: { name: PwaIconName; size?: number; strokeWidth?: number; style?: CSSProperties }) {
  return (
    <svg style={style} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      {paths[name]}
    </svg>
  );
}
